<template>
  <v-layout wrap>
    <v-flex sm12 class="white--text">
      <p>{{ participant.name }}</p>
    </v-flex>
    <v-flex sm12 class="white--text">
      <p>{{ participant.work }}</p>
    </v-flex>
    <v-flex sm12>
      <v-form ref="form">
        <v-layout wrap>
          <v-flex v-for="(pd, index) in personalData" :key="index" sm12>
            <v-select
              v-if="pd.options.length > 0"
              :label="pd.optionName"
              dark
              :items="pd.options"
              item-text="name"
              return-object
              v-model="selected[pd.optionType]"
              :rules="requiredRule"
              required
            ></v-select>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>

    <v-flex xs12 class="d-flex flex-row-reverse">
      <v-btn @click="send" rounded class="white" style="padding: 0 1rem">Continuar</v-btn>
    </v-flex>

    <v-snackbar v-model="snackbar" right top :timeout="3000">
      {{ message }}
      <v-btn color="blue" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      participant: JSON.parse(sessionStorage.getItem("participant")),
      requiredRule: [v => !!v || "Este campo es obligatorio"],
      snackbar: false,
      message: "",
      personalData: [],
      selected: {},
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    send() {
      let keys = Object.keys(this.selected);
      let valid = 0;
      keys.forEach(element => {
        if (this.selected[element].hasOwnProperty("name")) {
          valid++;
        } else {
          valid--;
        }
      });

      if (valid == keys.length) {
        const fd = new FormData();
        //solo guardar idoption en participants
        keys.forEach(element => {
          fd.append("options[]", this.selected[element].idOption);
        });
        fd.append("idParticipant", this.participant.idParticipant);
        fd.append("idUser", this.$route.params.idUser);

        axios
          .post(this.host + "/questionnaire/createoptions.php", fd)
          .then(response => {
            if (!response.data.status) {
              this.snackbar = true;
              this.message = response.data.message;
            } else {
              this.$router.push({ name: "participantquestionnaire" });
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.snackbar = true;
        this.message = "Los campos son necesarios";
      }
    },
    getData() {
      let data = {
        idUser: this.$route.params.idUser
      };

      axios
        .post(
          this.host + "/personaldataoptions/read.php",
          this.createFormData(data)
        )
        .then(response => {
          this.personalData = response.data.data;
          response.data.data.forEach(element => {
            if (element.options.length > 0) {
              this.selected[element.optionType] = {};
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    createFormData(postData) {
      let formDa = new FormData();
      for (let key in postData) {
        formDa.append(key, postData[key]);
      }
      return formDa;
    }
  },
  mounted() {
    this.getData();
  }
};
</script>